import React from 'react'
import { Component } from 'reflux'
import { Box, IconButton, Paper, Typography, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import { ProductSyncActions, ProductSyncStore } from '../../stores/productSyncStore'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { Link } from 'react-router-dom'

export default class ProductSyncOverview extends Component {
  constructor(props) {
    super(props)
    this.store = ProductSyncStore
    this.storeKeys = ['products', 'pageInfo', 'totalCount', 'suppliers']
  }

  componentDidMount() {
    ProductSyncActions.getSuppliersWithProductSync()
  }

  render() {
    const suppliers = this.state?.suppliers || []

    return (
      <Paper style={{ padding: '15px' }}>
        <Box mb={2}>
          <Typography variant='h5'>Product Sync Suppliers</Typography>
        </Box>

        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Supplier</TableCell>
              <TableCell>UID</TableCell>
              <TableCell align='right'>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {suppliers.map(s => (
              <TableRow key={s.SupplierID} hover>
                <TableCell>{s.supplierName}</TableCell>
                <TableCell>{s.SupplierID}</TableCell>
                <TableCell>{s.supplierUID}</TableCell>
                <TableCell align='right'>
                  <IconButton
                    component={Link}
                    to={`/product-sync/details/${s.SupplierID}`}
                    size='small'
                    color='primary'
                    aria-label={`View details for ${s.supplierName}`}
                  >
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            {suppliers.length === 0 && (
              <TableRow>
                <TableCell colSpan={4}>
                  <Typography variant='body2' color='textSecondary'>
                    No suppliers found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    )
  }
}
